import { canvasPreview } from './canvasPreview'

let previewUrl = ''

function toBlob(canvas, name, settings) {

    settings ??= { type: "image/jpeg", quality: 0.7 };

    return new Promise((resolve, reject) => {
        canvas.toBlob(blob => {
            if (!blob) {
                console.error('Canvas is empty');
                reject(new Error('Canvas is empty'));
                return;
            }
            blob.name = name;
            resolve(blob);
        }, settings.type, settings.quality);
    });
}

// Returns an image source you should set to state and pass
// `{previewSrc && <img alt="Crop preview" src={previewSrc} />}`
export async function imgPreview(
    image,
    crop,
    name,
    settings
) {
    const canvas = document.createElement('canvas');
    canvasPreview(image, canvas, crop);

    const blob = await toBlob(canvas, name, settings);

    if (!blob) {
        console.error('Failed to create blob');
        return '';
    }

    previewUrl = canvas.toDataURL('image/jpeg', 0.7);
    return { previewUrl, blob };
};